<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2022-04-02 14:35:07
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-04-02 15:17:36
-->
<template>
  <div class="sailingPlanSuccess">
    <div class="title">恭喜您！</div>
    <div class="tip">已成功报名武汉市启航计划</div>
    <img src="@/assets/home/sailingPlan_success.png" alt="" />
    <p>收到信息后，我们将尽快与您联系！</p>
    <p>请耐心等待！</p>
    <div class="btn" @click="toIndex">我知道了</div>
  </div>
</template>
<script>
export default {
  name: 'SailingPlanSuccess',
  methods: {
    toIndex() {
      this.$router.push('/sailingPlan')
    },
  },
}
</script>
<style lang="scss" scoped>
.sailingPlanSuccess {
  padding-top: 80px;
  text-align: center;
  .title {
    font-size: 36px;
    font-weight: bold;
    color: #49a4ff;
    margin-bottom: 25px;
  }
  .tip {
    font-size: 30px;
    font-weight: 400;
    color: #666666;
    margin-bottom: 40px;
  }
  > img {
    width: 270px;
    height: 240px;
    margin-bottom: 50px;
  }
  > p {
    font-size: 26px;
    font-weight: 400;
    color: #666666;
    &:last-of-type {
      margin-bottom: 40px;
    }
  }
  .btn {
    width: 400px;
    height: 80px;
    background: #49a4ff;
    border-radius: 40px;
    margin: 0 auto;
    font-size: 30px;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    line-height: 80px;
  }
}
</style>
